import { useMutation } from '@tanstack/react-query';
import { UserWalletCompanyInfoService } from 'services/openapi';

type CreateCompMutationVariables = {
  compName: string;
  compInfo: string;
};

export const useCreateCompMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, CreateCompMutationVariables>({
      mutationFn: (variables: CreateCompMutationVariables) => {
        return UserWalletCompanyInfoService.companyControllerCreateComp(
          variables,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
